import { useContext } from 'react';
import { ReadyStateSubscriptionContext } from '@/containers/AppReadyState/Context';

export const useAppReadySubscription = () => {
  return useContext(ReadyStateSubscriptionContext);
};